"use client";
import { useDictionary } from "@/components/DictProvider/DictProvider";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

// SVG paths extracted from DesktopFooter — each renders inside a white
// 40x40 circle with a black glyph, matching the reference's compact row.
const SOCIALS: Array<{ name: string; href: string; path: string }> = [
  {
    name: "youtube",
    href: "https://www.youtube.com/@CAMOUFLAGE-bo8he",
    path:
      "M18 23L23.19 20L18 17V23ZM29.56 15.17C29.69 15.64 29.78 16.27 29.84 17.07C29.91 17.87 29.94 18.56 29.94 19.16L30 20C30 22.19 29.84 23.8 29.56 24.83C29.31 25.73 28.73 26.31 27.83 26.56C27.36 26.69 26.5 26.78 25.18 26.84C23.88 26.91 22.69 26.94 21.59 26.94L20 27C15.81 27 13.2 26.84 12.17 26.56C11.27 26.31 10.69 25.73 10.44 24.83C10.31 24.36 10.22 23.73 10.16 22.93C10.09 22.13 10.06 21.44 10.06 20.84L10 20C10 17.81 10.16 16.2 10.44 15.17C10.69 14.27 11.27 13.69 12.17 13.44C12.64 13.31 13.5 13.22 14.82 13.16C16.12 13.09 17.31 13.06 18.41 13.06L20 13C24.19 13 26.8 13.16 27.83 13.44C28.73 13.69 29.31 14.27 29.56 15.17Z",
  },
  {
    name: "tiktok",
    href: "https://www.tiktok.com/@camouflage_kwt?_t=8mrbvkeSw24&_r=1",
    path:
      "M23.6 13.82C22.9164 13.0396 22.5397 12.0374 22.54 11H19.45V23.4C19.4261 24.071 19.1428 24.7066 18.6597 25.1729C18.1766 25.6393 17.5314 25.8999 16.86 25.9C15.44 25.9 14.26 24.74 14.26 23.3C14.26 21.58 15.92 20.29 17.63 20.82V17.66C14.18 17.2 11.16 19.88 11.16 23.3C11.16 26.63 13.92 29 16.85 29C19.99 29 22.54 26.45 22.54 23.3V17.01C23.793 17.9099 25.2973 18.3926 26.84 18.39V15.3C26.84 15.3 24.96 15.39 23.6 13.82Z",
  },
  {
    name: "linkedin",
    href:
      "https://www.linkedin.com/in/camouflage-for-hunting-and-fishing-845b2b244/?originalSubdomain=kw",
    path:
      "M14.94 13C14.9397 13.5305 14.7288 14.0391 14.3535 14.4139C13.9782 14.7888 13.4694 14.9993 12.939 14.999C12.4086 14.9988 11.9 14.7878 11.5251 14.4125C11.1502 14.0373 10.9397 13.5285 10.94 12.998C10.9403 12.4676 11.1512 11.959 11.5265 11.5841C11.9018 11.2092 12.4106 10.9988 12.941 10.999C13.4714 10.9993 13.98 11.2103 14.3549 11.5855C14.7298 11.9608 14.9403 12.4696 14.94 13ZM15 16.48H11V29H15V16.48ZM21.32 16.48H17.34V29H21.28V22.43C21.28 18.77 26.05 18.43 26.05 22.43V29H30V21.07C30 14.9 22.94 15.13 21.28 18.16L21.32 16.48Z",
  },
  {
    name: "facebook",
    href: "https://www.facebook.com/share/EUL38efQ2KyyLkdv/?mibextid=LQQJ4d",
    path:
      "M21.397 28.9972V20.8012H24.162L24.573 17.5922H21.397V15.5482C21.397 14.6222 21.655 13.9882 22.984 13.9882H24.668V11.1272C23.8486 11.0394 23.025 10.997 22.201 11.0002C19.757 11.0002 18.079 12.4922 18.079 15.2312V17.5862H15.332V20.7952H18.085V28.9972H21.397Z",
  },
  {
    name: "instagram",
    href: "https://www.instagram.com/camouflage_kwt/?igshid=1lfuqokhivzxa",
    path:
      "M15.8 10H24.2C27.4 10 30 12.6 30 15.8V24.2C30 25.7383 29.3889 27.2135 28.3012 28.3012C27.2135 29.3889 25.7383 30 24.2 30H15.8C12.6 30 10 27.4 10 24.2V15.8C10 14.2617 10.6111 12.7865 11.6988 11.6988C12.7865 10.6111 14.2617 10 15.8 10ZM15.6 12C14.6452 12 13.7295 12.3793 13.0544 13.0544C12.3793 13.7295 12 14.6452 12 15.6V24.4C12 26.39 13.61 28 15.6 28H24.4C25.3548 28 26.2705 27.6207 26.9456 26.9456C27.6207 26.2705 28 25.3548 28 24.4V15.6C28 13.61 26.39 12 24.4 12H15.6ZM25.25 13.5C25.5815 13.5 25.8995 13.6317 26.1339 13.8661C26.3683 14.1005 26.5 14.4185 26.5 14.75C26.5 15.0815 26.3683 15.3995 26.1339 15.6339C25.8995 15.8683 25.5815 16 25.25 16C24.9185 16 24.6005 15.8683 24.3661 15.6339C24.1317 15.3995 24 15.0815 24 14.75C24 14.4185 24.1317 14.1005 24.3661 13.8661C24.6005 13.6317 24.9185 13.5 25.25 13.5ZM20 15C21.3261 15 22.5979 15.5268 23.5355 16.4645C24.4732 17.4021 25 18.6739 25 20C25 21.3261 24.4732 22.5979 23.5355 23.5355C22.5979 24.4732 21.3261 25 20 25C18.6739 25 17.4021 24.4732 16.4645 23.5355C15.5268 22.5979 15 21.3261 15 20C15 18.6739 15.5268 17.4021 16.4645 16.4645C17.4021 15.5268 18.6739 15 20 15ZM20 17C19.2044 17 18.4413 17.3161 17.8787 17.8787C17.3161 18.4413 17 19.2044 17 20C17 20.7956 17.3161 21.5587 17.8787 22.1213C18.4413 22.6839 19.2044 23 20 23C20.7956 23 21.5587 22.6839 22.1213 22.1213C22.6839 21.5587 23 20.7956 23 20C23 19.2044 22.6839 18.4413 22.1213 17.8787C21.5587 17.3161 20.7956 17 20 17Z",
  },
  {
    name: "whatsapp",
    href: "https://wa.me/96594979199",
    path:
      "M20.05 10C14.53 10 10.05 14.48 10.05 20C10.05 21.85 10.55 23.55 11.43 25.04L10 30L15.09 28.59C16.52 29.38 18.23 29.98 20.05 29.98C25.53 29.98 30 25.52 30 20C30 17.34 28.95 14.84 27.07 12.93C25.18 11.05 22.68 10 20.05 10ZM20.05 12C22.15 12 24.12 12.84 25.66 14.34C27.16 15.88 28 17.87 28 20C28 24.41 24.41 28 20.05 28C18.49 28 17.06 27.58 15.81 26.84L15.42 26.61L12.29 27.41L13.09 24.37L12.84 23.95C12.01 22.64 11.55 21.12 11.55 19.5L12.05 20C12.05 15.59 15.59 12 20.05 12ZM16.54 15.5C16.36 15.5 16.06 15.57 15.81 15.84C15.55 16.1 14.83 16.78 14.83 18.15C14.83 19.53 15.83 20.85 15.97 21.05C16.12 21.24 17.93 24.08 20.76 25.13C21.37 25.37 21.85 25.5 22.22 25.6C22.83 25.78 23.39 25.76 23.82 25.69C24.31 25.6 25.16 25.01 25.38 24.35C25.59 23.7 25.59 23.14 25.52 23.02C25.45 22.91 25.26 22.84 24.97 22.7C24.68 22.55 23.31 21.88 23.05 21.78C22.79 21.68 22.61 21.63 22.42 21.92C22.23 22.2 21.7 22.84 21.54 23.02C21.39 23.21 21.23 23.23 20.94 23.09C20.65 22.94 19.74 22.64 18.66 21.68C17.82 20.93 17.24 20.01 17.09 19.72C16.94 19.43 17.07 19.27 17.22 19.13C17.35 19 17.51 18.79 17.65 18.64C17.8 18.49 17.84 18.38 17.95 18.19C18.05 18 18 17.84 17.93 17.7C17.85 17.55 17.26 16.18 17.03 15.69C16.8 15.22 16.56 15.5 16.54 15.5Z",
  },
];

// Convert Latin digits to Arabic-Indic when the current locale is AR,
// matching the existing DesktopFooter behavior so year formatting is
// consistent across footer variants.
function localizedYear(lang: string): string {
  const year = new Date().getFullYear().toString();
  if (lang !== "ar") return year;
  return year
    .split("")
    .map((digit) => String.fromCharCode(0x0660 + parseInt(digit, 10)))
    .join("");
}

export default function MobileFooter() {
  const dictionary = useDictionary();
  const pathName = usePathname();
  const lang = pathName?.split("/")[1] || "en";

  return (
    <footer className="md:hidden w-full bg-black text-white flex flex-col items-center gap-5 px-4 py-8">
      {/* Logo */}
      <Image
        src="/images/whitelogo.png"
        width={120}
        height={80}
        alt="Camouflage"
        unoptimized
      />

      {/* Social icons row */}
      <div className="flex justify-center items-center gap-3 flex-wrap">
        {SOCIALS.map((s) => (
          <Link
            key={s.name}
            href={s.href}
            target="_blank"
            prefetch={false}
            aria-label={s.name}
          >
            <svg
              width="36"
              height="36"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="20" cy="20" r="20" fill="white" />
              <path d={s.path} fill="black" />
            </svg>
          </Link>
        ))}
      </div>

      {/* App store badges */}
      <div className="flex justify-center items-center gap-3 flex-wrap">
        <a
          href="https://play.google.com/store/apps/details?id=com.camouflagekw"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Google Play"
        >
          <Image
            src="/images/playstorestr.svg"
            width={140}
            height={40}
            alt="Get it on Google Play"
          />
        </a>
        <a
          href="https://apps.apple.com/in/app/camouflage/id6738765156"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="App Store"
        >
          <Image
            src="/images/iphonestr.svg"
            width={140}
            height={40}
            alt="Download on the App Store"
          />
        </a>
      </div>

      {/* Copyright */}
      <p className="text-xs text-center leading-relaxed">
        &#169; {localizedYear(lang)} {dictionary?.footerPage?.copyright}
      </p>
    </footer>
  );
}
